import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';

import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgModule } from '@angular/core';
import { RxExpansionPanelComponent } from './rx-expansion-panel.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxRoleGuardModule } from '@nrwl/rx-directives';

@NgModule({
  imports: [
    CommonModule,
    RxIconModule,
    MatExpansionModule,
    MatMenuModule,
    MatListModule,
    RxRoleGuardModule,
    RxExpansionPanelComponent,
  ],
  exports: [RxExpansionPanelComponent, MatExpansionModule, MatMenuModule, MatListModule],
})
export class RxExpansionPanelModule {}
